import { ReactNode } from "react";
import * as CSS from "csstype";
import { Heading as ChakraHeading, HTMLChakraProps } from "@chakra-ui/react";
import { theme } from "theme";
import { ResponsiveValue } from "@chakra-ui/system";

type HeadingProps = {
	children: ReactNode | string;
	className?: string;
} & Pick<HTMLChakraProps<"h2">,
	"color" | "fontFamily" | "fontSize" | "fontWeight" | "lineHeight"
>

export const Heading: React.FC<HeadingProps> = (
	{
		className,
		color = "white",
		children,
		fontFamily = theme.fonts.sans_serif_heading,
		fontWeight = 400,
		fontSize,
		lineHeight = "1.25"
	}
) => {
	return <ChakraHeading className={className}
		color={color} fontFamily={fontFamily}
		fontWeight={fontWeight} m={0}
		lineHeight={lineHeight}
		fontSize={fontSize}>{children}
	</ChakraHeading>;
};
